<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <div
    class="switch-ctrl"
    :data-qa="dataQa ? `${dataQa}_container` : null"
  >
    <div
      v-if="label"
      :data-qa="dataQa ? `${dataQa}_label` : null"
    >
      {{ label }}
    </div>
    <div
      class="switch"
      :class="{checked: checked}"
      :data-qa="dataQa"
      @click="toggle"
    >
      <span
        class="slider round"
        :data-qa="dataQa ? `${dataQa}_switch_handle` : null"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormSwitch',
  props: {
    isOn: Boolean,
    label: {
      type: String,
      default: null
    },
    dataQa: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      checked: false
    };
  },
  created () {
    this.checked = this.isOn;
  },
  methods: {
    toggle: function () {
      this.checked = !this.checked;
      this.$emit('change', this.checked);
    }
  }
};
</script>
